import Configs from '../constants/configs';

export class PageEvent {
  page: number;
  limit: number;
  sort: any;

  constructor(page?: number,
    limit?: number,
    sort?: any) {
    this.page = page || Configs.pagination.startPage;
    this.limit = limit || Configs.pagination.defaultSize;
    this.sort = sort || '';
  }

  query() {
    const data: any = {};
    if (this.page != null) {
      data['page'] = this.page;
    }

    if (this.limit != null) {
      data['limit'] = this.limit;
    }

    if (this.sort != null) {
      data['sort'] = this.sort;
    }

    return data;
  }
}
